import * as React from "react";
import { List, Datagrid, TextField, TextInput, SelectInput, NumberField, Filter } from 'react-admin';
import { MyPagination } from './pagination';
import { useRecordContext } from 'react-admin';

const BarcodeField = () => {
    const record = useRecordContext();
    return (
        <ul>
            {record.barcode.map(item => (
                <ol>{item}</ol>
            ))}
        </ul>
    )
};

const choicesShop = [
    { id: 501, name: '501' },
    { id: 502, name: '502' },
    { id: 503, name: '503' },
    { id: 504, name: '504' },
    { id: 505, name: '505' },
];

const ProductCsCartFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <SelectInput label="WebShop" source="shop_id" choices={choicesShop} allowEmpty={false} optionText="name" optionValue="id" alwaysOn />
    </Filter>
);

export const ProductCsCartsList = (props) => (
    <List {...props} title='Товары CSCART' filters={<ProductCsCartFilter />} pagination={<MyPagination/>}>
        <Datagrid rowClick="show">
            <TextField source="id" label="ID" sortable={false} />
            <BarcodeField source="barcode" label="barcode" sortable={false} />
            <TextField source="brand_id" label="brand_id" sortable={false} />
            <TextField source="brand_name" label="brand" sortable={false} />            
            <TextField source="country_id" label="country_id" sortable={false} />
            <TextField source="country_name" label="country" sortable={false} />
            <TextField source="detail_ro" label="ro" sortable={false} />
            <TextField source="detail_ru" label="ru" sortable={false} />
            <TextField source="eda_termgood_hours" label="shelf life" sortable={false} />
            <TextField source="import_flag" label="import_flag" sortable={false} />
            <TextField source="mbrutto" label="mbrutto" sortable={false} />
            <TextField source="mbnetto" label="mbnetto" sortable={false} />
            <TextField source="pricekg" label="pricekg" sortable={false} />
            <TextField source="g_103t" label="g_103t" sortable={false} />
            <NumberField source="shop_id" label="shop_id" sortable={false} />
        </Datagrid>
    </List>
);
